/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export * from "./index-en-us";
export * from "./index-ja-jp";
